<script setup lang="ts">
import { isTrustpilotEmbed, parseTrustpilotEmbed } from '~/composables/parseTrustpilotEmbed'
import { trustpilotEmbedHeight, trustpilotFallbackVariant } from '~/composables/trustpilotFallbackVariant'

const props = defineProps<{
  model: {
    htmlToEmbed?: { value: string }
    containerClass?: { value: string }
  }
}>()

const html = computed(() => props.model?.htmlToEmbed?.value ?? '')
const containerClass = computed(() => props.model?.containerClass?.value || '')
const isTrustpilot = computed(() => isTrustpilotEmbed(html.value))
const embed = computed(() => parseTrustpilotEmbed(html.value))
const businessUnitId = computed(() => embed.value?.businessUnitId ?? '')
const variant = computed(() => trustpilotFallbackVariant(embed.value?.templateId))
const minHeight = computed(() => trustpilotEmbedHeight(html.value))
const alwaysCookieless = useTrustpilotAlwaysCookieless()
</script>

<template>
  <div
    class="trustpilot-block mx-auto mb-(--block-spacing)"
    :class="containerClass"
    :style="minHeight ? { minHeight } : undefined"
    data-testid="trustpilot-container"
  >
    <TrustpilotWidgetGate
      v-if="isTrustpilot"
      :widget-html="html"
      :always-cookieless="alwaysCookieless"
    >
      <CompanyTrustpilotSummary
        :business-unit-id="businessUnitId"
        :variant="variant"
      />
    </TrustpilotWidgetGate>
  </div>
</template>

<style lang="scss">
.page-block-area {
  .trustpilot-block {
    @media (min-width: 1600px) {
      width: var(--block-width-wide);
    }
  }
}
</style>
